import React from 'react'
import clsx from 'clsx'
import { Sidebar } from './Sidebar'
import { MobileNav } from './MobileNav'
import { MinimalFooter } from './Footer'

export interface AppLayoutProps {
  children: React.ReactNode
  showSidebar?: boolean
  showHeader?: boolean
  className?: string
}

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  showSidebar = true,
  showHeader = false,
  className,
}) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false)

  return (
    <div className="min-h-screen bg-transparent flex">
      {/* Desktop sidebar */}
      {showSidebar && (
        <>
          <div className="hidden lg:flex lg:flex-shrink-0">
            <Sidebar />
          </div>

          {/* Mobile sidebar overlay */}
          {sidebarOpen && (
            <div className="fixed inset-0 z-50 flex lg:hidden">
              <div 
                className="fixed inset-0 bg-black/60 backdrop-blur-sm"
                onClick={() => setSidebarOpen(false)}
              />
              <div className="relative flex flex-col flex-1 max-w-[280px]">
                <Sidebar onClose={() => setSidebarOpen(false)} />
              </div>
            </div>
          )}
        </>
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        <main className={clsx('flex-1 relative', className)}>
          {showHeader && <div className="sr-only" aria-hidden="true" />}
          {children}
        </main>

        <MinimalFooter className={showSidebar ? 'pb-20 lg:pb-4' : undefined} />

        {showSidebar && (
          <div className="lg:hidden">
            <MobileNav />
          </div>
        )}
      </div>
    </div>
  )
}

export { AppLayout }
